import {
  SAVE_FORGOT_PASSWORD_UNKNOWN_USER_DATA,
  RESET_FORGOT_PASSWORD_UNKNOWN_USER_DATA
} from 'Store/constants';

const initialState = {
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SAVE_FORGOT_PASSWORD_UNKNOWN_USER_DATA:
      return { data: action.payload };
    case RESET_FORGOT_PASSWORD_UNKNOWN_USER_DATA:
      return { data: initialState };
    default:
      return state;
  }
};
